import { Node, Edge } from "@antv/x6"

export enum SelectedType {
  Line,
  Node,
  Spreadsheet,
  Other,
  SvgStream,
}

export enum PanelType {
  Cell = 1,
  AllUnits,
  Graph,
  Template,
  Spreadsheet,
  Line,
  SimLogs,
  PPST
}

export enum OtherPanelType {
  Setting,
  AllUnit,
  NodeSetting
}

export interface OtherPanel {
  type: OtherPanelType
}

export interface SelectedCell {
  type: SelectedType
  unit?: Node | Edge
  other?: OtherPanel
}